import AppText from './app_text';
const Subheader = AppText.withComponent('h2');
Subheader.defaultProps = {
    size: 'large',
    headingFontFamily: true,
};
export default Subheader;
//# sourceMappingURL=subheader.js.map